import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import Minus from '@images/minus.svg';
import Plus from '@images/plus.svg';

interface Props {
  onAdd: React.MouseEventHandler<HTMLButtonElement>;
  onRemove: React.MouseEventHandler<HTMLButtonElement>;
  quantity: number;
}

const QuantityAddToCart: React.FC<Props> = ({ onAdd, onRemove, quantity }) => (
  <Container className="quantity-container">
    <IconWrap onClick={onRemove} disabled={quantity <= 1} aria-label="decrease quantity">
      <Minus />
    </IconWrap>
    <Quantity>{quantity}</Quantity>
    <IconWrap onClick={onAdd} aria-label="increase quantity">
      <Plus />
    </IconWrap>
  </Container>
);

export default QuantityAddToCart;

interface StyleProps {
  disabled?: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  border-right: 1px solid #faead6;
`;

const IconWrap = styled.button`
  all: unset;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: ${Colors.paleGold};
  border-radius: 2px;
  width: 30px;
  height: 30px;
  margin-inline: 15px;
  opacity: ${(props: StyleProps) => props.disabled && '0.5'};
`;

const Quantity = styled.div`
  font-family: Domaine;
  font-size: 25px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  text-align: left;
`;
